import React from "react";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
import userProfiler from "web/script/modules/userprofiler";
import { useProductCardContext } from "./product-card";
import styles from "./product-card-save-for-later.css";

function ProductCardSaveForLater(): React.ReactElement | null {
    const { id, image_url: imageURL } = useProductCardContext();

    return (
        <div className={styles.saveForLater}>
            <SaveForLaterButton
                type="icon"
                isLoggedIn={userProfiler.isLoggedIn()}
                pageSource="feed"
                productId={id.toString()}
                productImageURL={imageURL?.toString()}
            />
        </div>
    );
}

export default ProductCardSaveForLater;
